import React, {Component} from 'react';
import {Form, Input,Select, Row, Col, Checkbox,Modal, Button,DatePicker,Cascader,message} from 'antd';	
import { connect } from 'react-redux';
import moment from 'moment';

import {getAllAssistListAPI,getTreeListAPI, createImageCorrectionTaskAPI} from '@/API'
import TreeSection from './tree_section'
import { ASSIST } from '@/utils/questionManageType';
const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class CreateTaskModal extends Component{
	state={
		postForm:{
			relate_id:undefined,
			root_id:undefined,
		},
		btnLoading:false,
		sectionList:[],
		assistTreeList:[]
	}
	componentDidMount(){
		this.getSectionList()
	}
	formatLoop(data){
		return data.map(item=>{
				let option = { value: item.assist_id || item.book_id || item.edition_id, label: item.name }
	            if (item.list) option.children = this.formatLoop(item.list)
	            return option;
			})
	}
	//获取课本教辅
	getSectionList(){
		getAllAssistListAPI().then(res=>{
			let sectionList=this.formatLoop(res.data.list)
			this.setState({sectionList})
		})
	}
	handleSectionChange= (value) => {
        let rootId = value[value.length - 1];
        let params={
        		type: ASSIST, 
        		rootId
        }
        this.getTreeList(params)
    }
	handleTreeCheck=(selectedKeys)=>{
		let {postForm}=this.state
		postForm.relate_id=selectedKeys
        this.setState({postForm})
    }
	getTreeList(params){
		getTreeListAPI(params).then(res=>{
			this.setState({assistTreeList:res.data.list})
		})
	}
	disabledDate=(current)=> {
	  return current && current.valueOf() < Date.now();
	}
	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
			let {postForm}=values
	      	 postForm.sign_dead_time=moment(postForm.sign_dead_time).format('YYYY-MM-DD')
	      	 postForm.icon_dead_time=moment(postForm.icon_dead_time).format('YYYY-MM-DD')
	      	 postForm.relate_id=this.state.postForm.relate_id
	      	 if(!postForm.relate_id.length){
	      	 	message.error('请选择具体章节')
	      	 	return
	      	 }
	      	 this.setState({btnLoading:true})
	      	 createImageCorrectionTaskAPI(postForm).then(res=>{
	      	 	message.success('任务创建成功！');
	      	 	this.setState({btnLoading:false})
	      	 	this.props.handleClose('update')
	      	 	this.props.form.resetFields();
	      	 	this.resetPostForm()
	      	 }).catch(e=>{
	      	 	this.setState({btnLoading:false})
	      	 })
	      }
	    });
	 }
	resetPostForm(){
		let initPostForm={
			relate_id:undefined,
			root_id:undefined,
		}
		this.setState({postForm:initPostForm})
	}
	renderForm(){
		
		const ruleOption={
			input:{rules: [{ required: true, message: '必填项!', whitespace: true }]},
			date:{rules: [{ type: 'object',required: true, message: '必填项!'}]},
			cascader:{rules: [{ type: 'array',required: true, message: '必填项!'}]},
		}
		
		let {sectionList,assistTreeList}=this.state
		const { getFieldDecorator } = this.props.form;

	    let { sign_user_list,icon_user_list,icon_leader_list,icon_check_user_list,check_user_list}=this.props.memberList

		const markManOptions = sign_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>);    
	    const exerciseVerifierOptions = check_user_list.map(v => <Option value={v.id} key={v.id}>{v.username}</Option>); 
	    const groupLeaderOptions = icon_leader_list.map(v => <Option value={v.id} key={v.id}>{v.username}</Option>);
	   
	   return(
	    		<Form >
				<FormItem {...formItemLayout} label="任务名称" hasFeedback>
		          {getFieldDecorator('postForm.name', ruleOption.input)(<Input /> )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="标记人" hasFeedback>
		          {getFieldDecorator('postForm.sign_user', ruleOption.input)(
		          	<Select
		          		showSearch
				        defaultActiveFirstOption={false}
				        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
				      >
	       				{markManOptions}
	       			 </Select>
		          )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="标记截止时间" hasFeedback>
		          {getFieldDecorator('postForm.sign_dead_time', ruleOption.date)(<DatePicker  disabledDate={this.disabledDate} />)}
		        </FormItem>
		        <FormItem {...formItemLayout} label="标记审核人" hasFeedback>
		          {getFieldDecorator('postForm.sign_check_user', ruleOption.input)(
		          	<Select
	       				showSearch
				        defaultActiveFirstOption={false}
				        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
				      >
	       				{exerciseVerifierOptions}
	       			 </Select>
		          )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="插画组长" hasFeedback>
		          {getFieldDecorator('postForm.icon_leader', ruleOption.input)(
		          	<Select
	       				showSearch
				        defaultActiveFirstOption={false}
				        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
				      >
	       				{groupLeaderOptions}
	       			 </Select>
		          )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="插画截止时间" hasFeedback>
		          {getFieldDecorator('postForm.icon_dead_time')(<DatePicker disabledDate={this.disabledDate}/> )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="" >
		          {getFieldDecorator('postForm.skip_finish', { valuePropName: 'checked',initialValue:true })(<Checkbox >跳过已有图片订正任务的题目</Checkbox> )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="章节" hasFeedback>
		          {getFieldDecorator('postForm.root_id', ruleOption.cascader)( <Cascader  popupPlacement="topLeft" allowClear={ false } options={sectionList} placeholder="请选择章节" onChange={ this.handleSectionChange } /> )}
		        </FormItem>
		        <TreeSection
                    treeData={assistTreeList }
                    key = { ASSIST }
                    handleTreeCheck = { selectedKeys => this.handleTreeCheck(selectedKeys) }
                    checkable= { true }
                    checkStrictly = { false }
                />
			</Form>
	    )
		
	}
	
	render(){
		let {btnLoading}=this.state
		let {openCreate,handleClose}=this.props
		return(
			<Modal
	          title="新建任务"
	          visible={openCreate}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>保存</Button>,
	          ]}
	        >
				{this.renderForm()}
			 </Modal>
		)
	}
}


export const WrappedCreateTaskForm = Form.create()(CreateTaskModal)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/modal/create_task.js